import { useCallback, useEffect, useMemo, useState } from "react";
import { FlowioInputValue, TemplateId } from "src/globalTypes";
import { EditRowWithColumns } from "src/requests/tableRowActions/types";
import { useOverviewTableForTemplateIdAutoFETCH } from "src/store/overviewTables/useActions";
import { useIsOverviewTablesLoading } from "src/store/overviewTables/useSelectors";

type UseRelationTableRowDataReturnType = {
  tableRowData: EditRowWithColumns;
  isLoading: boolean;
  setTableRowData: (data: EditRowWithColumns) => void;
};

const useRelationTableData = (
  value: FlowioInputValue | undefined,
  templateId: TemplateId
): UseRelationTableRowDataReturnType => {
  const isLoading = useIsOverviewTablesLoading();
  const overviewTable = useOverviewTableForTemplateIdAutoFETCH(templateId);

  const [tableRowData, setTableRowData] = useState<EditRowWithColumns>(
    {} as EditRowWithColumns
  );

  const tableRowWithColums = useMemo(() => {
    if (!overviewTable || !value) return {} as EditRowWithColumns;
    const { rows, columns } = overviewTable;
    const tableRow = rows.find((row) => row.keyValue === Number(value));

    const tableRowFiltered = rows.filter(
      (row) => row.keyValue === Number(value)
    );

    if (tableRowFiltered.length > 1) {
      const formElement = document.getElementById("tableRow");

      const values = formElement?.querySelectorAll("input");

      const vals: string[] = [];

      values?.forEach((val) => {
        vals.push(val.value);
      });

      const usefullVals = vals.reduce((acc, val) => acc + val, "").split(" ");

      const rigthRow = tableRowFiltered.find((row) => {
        const cellsValue = Object.values(row.cells).map((cell) => cell.value);

        return cellsValue.find((cellValue) =>
          usefullVals.includes(cellValue?.toString() ?? "")
        );
      });

      if (!rigthRow && !!tableRow) {
        return { row: tableRow, columns };
      }

      return { row: rigthRow, columns } as EditRowWithColumns;
    }

    if (!tableRow) return {} as EditRowWithColumns;

    return { row: tableRow, columns };
  }, [overviewTable, value]);

  useEffect(() => {
    if (Object.keys(tableRowWithColums).length > 0) {
      setTableRowData(tableRowWithColums);
    }
  }, [tableRowWithColums]);

  return {
    tableRowData,
    isLoading,
    setTableRowData,
  };
};

export default useRelationTableData;
